var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('b-row',[_c('b-col',[_c('ApplicationTitle')],1),(_vm.isThereNews)?_c('b-col',{staticClass:"text-left",attrs:{"md":"12","lg":"3"}},[_c('News',{attrs:{"items":_vm.news}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }